import { events, eventClick, viewRender } from './calMethods.js';
import { setDoc, clearDoc, findDoc, getAppsforCurrentDoc } from './doctorMethods.js';
import renderConfirmationView from './confirmationView.js';
import { doctors }  from './templates/doctors';


console.log('firing main.js');

$(document).ready(() => {
  window.PB = {
    shouldFetch: true,
  };
  console.log('doc ready');

  //Disables autoscroll to last position on reload
  if (history && 'scrollRestoration' in history) history.scrollRestoration = 'manual';

  //Scrolls to the top of the page to show any updates
  $(window).scrollTop(0);

  loadBusinessInfo();
  loadStaffForLocation();

});

function renderBusinessInfo(businessData) {
  if (businessData.info) {
    const {
      name, mailing_address_line_1,
      mailing_address_city, mailing_address_state
    } = businessData.info;

    const addr = `${mailing_address_line_1}, ${mailing_address_city}, ${mailing_address_state}`;

    $('.pb-business-info__title').html(name);
    $('.pb-business-info__address').html(addr);
  } else {
    console.log('malformed data retrieved');
  }
}

function loadBusinessInfo() {
  const business_id = $('#business-data').attr('data-business-id');
  $.ajax({
    url: `/business/id/${business_id}/public/info`,
    dataType: 'json',
    success: (data) => {
      const businessData = JSON.parse(data);
      renderBusinessInfo(businessData);
      renderCalendarView();
    },
    error: (jqXHR, status, error) => {
      console.log('error retreiving business info');
      console.log('status:', status);
      console.log('error:', error);
    }
  });
}

function loadStaffForLocation() {
  const business_id = $('#business-data').attr('data-business-id');
  const location_id = $('#business-data').attr('data-location-id');
  $.ajax({
    url: `/staff/business/${business_id}/location/${location_id}`,
    dataType: 'json',
    success: staffLoadedCallback,
    error: (jqXHR, status, error) => {
      console.log('error retreiving business info');
      console.log('status:', status);
      console.log('error:', error);
    }
  });
}

function staffChangeCallback() {
  const currentValue = $(this).val();
  if (currentValue === "" || currentValue === 'any') {
    $('#business-data').attr('data-doctor-id', '');
    clearDoc();
    resetEvents();
  } else {
    const doc = findDoc(currentValue);
    setDoc(doc);
    resetEvents();
  }
}

function resetEvents() {
  window.PB.shouldFetch = false;
  $('#calendar-wrapper').fullCalendar('refetchEvents');
  window.PB.shouldFetch = true;
  $('#times-wrapper').remove();
  $('#patient-info-row').remove();
}

function staffLoadedCallback(data) {
  const staffData = JSON.parse(data);
  window.PB.staff = staffData.staff;
  if (staffData.staff.length > 1) {
    $('.pb-doctors').append(doctors(staffData));
    $('.pb-select--doctors').change(staffChangeCallback);
  } else {
    const doc = staffData.staff[0];
    setDoc(doc);
  }
}


function renderCalendarView() {
  $('#calendar-wrapper').fullCalendar({
    header: {
      left: 'prev',
      center: 'title',
      right: 'next'
    },
    events, //fn to get events
    eventClick, //callback when event is clicked
    viewRender, //callback when new month is rendered
    showNonCurrentDates: false, //hide dates outside curr month
    fixedWeekCount: false,  //show # weeks in curr month
    height: 'auto', //sets calendar height; may want to use contentHeight
    eventBackgroundColor: '#853CAF',
    eventBorderColor: '#853CAF',
    eventTextColor: 'white',
  });
  window.PB.eventSource = $('#calendar-wrapper').fullCalendar('getEventSources')[0];
}



// WEBPACK FOOTER //
// ./public/src/main.js